import { render, staticRenderFns } from "./Push.vue?vue&type=template&id=c4762988&scoped=true"
import script from "./Push.vue?vue&type=script&lang=js"
export * from "./Push.vue?vue&type=script&lang=js"
import style0 from "./Push.vue?vue&type=style&index=0&id=c4762988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4762988",
  null
  
)

export default component.exports